import request from '@/utils/request'
import { xlsDownload } from '@/api/view/hip/common/commonXls'

export function epms9040List(param) {
    let data = param
    return request({
        url: `/deliveryControl/epms9040/epms9040List`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}

export function epms9040save(param) {
    let data = param
    return request({
        url: `/deliveryControl/epms9040/epms9040save`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}

export function epms9041head(param) {
    let data = param
    return request({
        url: `/deliveryControl/epms9040/epms9041head`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}

export function epms9041detail(param) {
    let data = param
    return request({
        url: `/deliveryControl/epms9040/epms9041detail`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}